import type { ContactFilterOptions, Option } from "@/types/entities";

/** API filter options use RENT/SALE; requirements store Rent/Buy. */
export function normalizeProfileIntentionFilter(value: string | undefined): string | undefined {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  if (trimmed.toUpperCase() === "RENT") return "Rent";
  if (trimmed.toUpperCase() === "SALE") return "Buy";
  return trimmed;
}

function normalizeIntentionOption(option: Option): Option {
  if (option.value === "RENT") return { label: "Rent", value: "Rent" };
  if (option.value === "SALE") return { label: "Buy", value: "Buy" };
  return option;
}

function normalizeActiveStateOption(option: Option): Option {
  if (option.value === "true") return { ...option, label: "Active" };
  if (option.value === "false") return { ...option, label: "Inactive" };
  return option;
}

export function normalizeContactFilterOptions(options: ContactFilterOptions): ContactFilterOptions {
  return {
    ...options,
    intentions: options.intentions.map(normalizeIntentionOption),
    activeStates: options.activeStates.map(normalizeActiveStateOption),
  };
}
